// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://dev.wrp.internal.noovle.com/api/wrp',
  noHeaderPaths: ['/login'],
  clientId:
    '21649333064-4d92j82krkn2fcjct2ssouiur1v9cbdq.apps.googleusercontent.com',
  permissions: {
    delegates: ['admin', 'approvers'],
    actions: ['admin', 'approvers', 'bpm_delegates_*'],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

/**
 * utente normale solo user
 * approvatore con delegati permission bpm_delegates.......*
 * approvatore di gruppo approver
 *
 * HEADER CLICK SU DELEGATES SU TUTTO IL BUTTON
 */
